module.exports = __webpack_public_path__ + "img/hit-pract-1.3a805cf5.svg";